import React, { Fragment, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import MenuVariaveis from '../../MenuVariaveis';

export default (props) => {
  const { answerHandlerOpen, toggleAnswerHandler, doUpdateItem, item } = props;

  const maxLengthSms = 160;

  const { i18n } = useTranslation();

  const [destinationContact, setDestinationContact] = useState(
    item.destinationContact || ''
  );
  const [message, setMessage] = useState(item.message || '');
  const [messageLenght, setMessageLenght] = useState(maxLengthSms);

  useEffect(() => {
    const itemMessage = item.message || '';
    setDestinationContact(item.destinationContact || '');
    setMessage(itemMessage);
    setMessageLenght(maxLengthSms - itemMessage.length);
  }, [item]);

  const onInputChanged = (value, state, name) => {
    state(value);
    const payload = {};
    payload[name] = value;

    if (name === 'message') {
      setMessageLenght(maxLengthSms - value.length);
    }

    console.log(payload);
    doUpdateItem(payload);
  };

  const handleSelectVariavel = (name, value, variavel, setState) => {
    const newValue = `${value} {${variavel}}`;

    setState(newValue);
    doUpdateItem({ [name]: newValue });
  };

  return (
    <Fragment>
      <p className="pointer handler-title" onClick={toggleAnswerHandler}>
        {i18n.t('Configurações de envio')}{' '}
        <img
          alt=""
          className={`seta-expander ${
            !answerHandlerOpen ? 'arrow-rotation' : ''
          }`}
          src="/assets/images/icons/seta_close.svg"
        />
      </p>

      {/* CONTADO DE DESTINO */}
      <MenuVariaveis
        onSelect={(variavel) =>
          handleSelectVariavel(
            'destinationContact',
            destinationContact,
            variavel,
            setDestinationContact
          )
        }
        buttonRight="27px"
        buttonBottom="25px"
        id={`bloco-${item._id}-configuracao-destinationContact`}
        isTooltip
        hidden={!answerHandlerOpen}
      >
        <div className="common-form-group">
          <label>{i18n.t('Contato de destino')}</label>
          <input
            type="text"
            placeholder="(00) 9 9999 9999"
            className="form-control mt-1"
            id="destinationContact-SMS"
            value={destinationContact}
            onChange={(e) =>
              onInputChanged(
                e.target.value,
                setDestinationContact,
                'destinationContact'
              )
            }
          />
        </div>
      </MenuVariaveis>

      {/* MENSAGEM */}
      <MenuVariaveis
        onSelect={(variavel) =>
          handleSelectVariavel('message', message, variavel, setMessage)
        }
        buttonRight="60px"
        buttonBottom="21px"
        id={`bloco-${item._id}-configuracao-message`}
        isTooltip
        hidden={!answerHandlerOpen}
      >
        <div className="common-form-group">
          <label>{i18n.t('Mensagem')}</label>
          <textarea
            maxLength={maxLengthSms}
            placeholder={i18n.t('Digite aqui a mensagem personalizada de SMS.')}
            className="form-control mt-1"
            id="message-SMS"
            value={message}
            onChange={(e) =>
              onInputChanged(e.target.value, setMessage, 'message')
            }
          />
          <div className="qnt-mensagem">({messageLenght})</div>
        </div>
      </MenuVariaveis>
    </Fragment>
  );
};
